import { Button } from "@mui/material";
import { saveAs } from "file-saver";
import { Document, Packer, Paragraph, Table as DocTable, TableRow as DocTableRow, TableCell as DocTableCell  } from "docx";
import { useTranslation } from "react-i18next";

const ExportToWord = ({ data, fileName = "CasoGestion_Informe.docx" }) => {
    const { t } = useTranslation();

    const handleExportToWord = async () => {
        const doc = new Document({
            sections: [
                {
                    properties: {},
                    children: [
                        new Paragraph({
                            text: t("Profiles.CaseManagementQuestionnaire.CaseManagementQuestionnaire"),
                            heading: "Title",
                        }),
                        new Paragraph(`${t("Profiles.CaseManagementQuestionnaire.PatientID")}: ${data.CaseManagementQuestionnaire.PatientID || "N/A"}`),
                        new Paragraph(`${t("Profiles.CaseManagementQuestionnaire.DateOfAssessment")}: ${data.CaseManagementQuestionnaire.DateOfAssessment || "N/A"}`),
                        new Paragraph(`${t("Profiles.CaseManagementQuestionnaire.PatientFullName")}: ${data.CaseManagementQuestionnaire.PatientFullName || "N/A"}`),
                        new Paragraph(`${t("Profiles.CaseManagementQuestionnaire.LocationOfAssessment")}: ${data.CaseManagementQuestionnaire.LocationOfAssessment || "N/A"}`),
                        new Paragraph(`${t("Profiles.CaseManagementQuestionnaire.WasInformationObtainedDuring")}: ${data.CaseManagementQuestionnaire.WasInformationObtainedDuring || "N/A"}`),
                        ...(data.WasInformationObtainedDuring === "yes"
                            ? [
                                  new Paragraph(`${t("Profiles.CaseManagementQuestionnaire.IfYesWho")}: ${data.CaseManagementQuestionnaire.IfYesWho || "N/A"}`),
                                  new Paragraph(`${t("Profiles.CaseManagementQuestionnaire.Relationship")}: ${data.CaseManagementQuestionnaire.Relationship || "N/A"}`),
                                  new Paragraph(`${t("Profiles.CaseManagementQuestionnaire.Phone")}: ${data.CaseManagementQuestionnaire.Phone || "N/A"}`),
                              ]
                            : []),
                        new Paragraph(t("Profiles.CaseManagementQuestionnaire.Pleaserefertothepatient’s")),
                    ],
                },{
                    properties: {},
                    children: [
                        new Paragraph({
                            text: t("Profiles.Education.Education"),
                            heading: "Title",
                        }),
                        new Paragraph(`${t("Profiles.Education.Educationallevel")}: ${data.Education.EducationalLevel || "N/A"}`),
                        new Paragraph(`${t("Profiles.Education.ReadingAbility/Literacy")}: ${data.Education.ReadingAbility || "N/A"}`),
                        new Paragraph(`${t("Profiles.Education.Race/Ethnicity")}: ${data.Education.RaceEthnicity || "N/A"}`),
                        ...(data.RaceEthnicity === "Other"
                            ? [
                                  new Paragraph(`${t("Profiles.Education.Other")}: ${data.Education.OtherRaceEthnicity || "N/A"}`),
                              ]
                            : []),
                    ],
                },{
                    properties: {},
                    children: [
                        new Paragraph({
                            text: t("Profiles.Housing.Housing"),
                            heading: "Title",
                        }),
                        new Paragraph(`${t("Profiles.Housing.HousingType")}: ${data.data.housingData.housingType || "N/A"}`),
                        ...(data.housingData.housingType === "Other"
                            ? [new Paragraph(`${t("Profiles.Housing.Explain")}: ${data.housingData.otherHousing || "N/A"}`)]
                            : []),
                        new Paragraph(`${t("Profiles.Housing.HousingStability")}: ${data.housingData.housingStability || "N/A"}`),
                        new Paragraph(`${t("Profiles.Housing.HasPhysicalConditions")}: ${data.housingData.hasPhysicalConditions || "N/A"}`),
                        ...(data.housingData.hasPhysicalConditions === "yes"
                            ? [new Paragraph(`${t("Profiles.Housing.PhysicalConditions")}: ${data.housingData.physicalConditions || "N/A"}`)]
                            : []),
                        new Paragraph(`${t("Profiles.Housing.OtherPersons")}: ${data.housingData.otherPersons || "N/A"}`),
                        ...(data.housingData.otherPersons === "yes" && data.housingData.householdMembers.length
                            ? [
                                new DocTable({
                                    rows: [
                                        new DocTableRow({
                                            children: [
                                                new DocTableCell({ children: [new Paragraph(t("Profiles.Housing.Name"))] }),
                                                new DocTableCell({ children: [new Paragraph(t("Profiles.Housing.Relationship"))] }),
                                                new DocTableCell({ children: [new Paragraph(t("Profiles.Housing.Age"))] }),
                                                new DocTableCell({ children: [new Paragraph(t("Profiles.Housing.MayWeContact?"))] })
                                            ]
                                        }),
                                        ...data.housingData.householdMembers.map(member =>
                                            new DocTableRow({
                                                children: [
                                                    new DocTableCell({ children: [new Paragraph(member.name || "N/A")] }),
                                                    new DocTableCell({ children: [new Paragraph(member.relationship || "N/A")] }),
                                                    new DocTableCell({ children: [new Paragraph(member.age || "N/A")] }),
                                                    new DocTableCell({ children: [new Paragraph(member.mayWeContact || "N/A")] })
                                                ]
                                            })
                                        )
                                    ]
                                })
                            ]
                            : []),
                            new Paragraph({
                                text: t("Profiles.Transportation.Transportation"),
                                heading: "Title",
                            }),
                            new Paragraph(`${t("Profiles.Transportation.Doesclienthaveaccesstotransportation?")}: ${data.Transportation.DoesClientHaveTransportation || "N/A"}`),
                            ...(data.transportationData.DoesClientHaveTransportation === "no"
                                ? [new Paragraph(`${t("Profiles.Transportation.Ifno,pleasedescribeclient’s")}: ${data.Transportation.pleasedescribeclient || "N/A"}`)]
                                : []),

                                new Paragraph({
                                    text: t("Profiles.Insurance.Insurance"),
                                    heading: "Title",
                                }),
                                new Paragraph(`${t("Profiles.Insurance.InsuranceDoyouhavehealth")}`),
                                new Paragraph(`${t("Profiles.Insurance.Medicare")}: ${data.Insurance.Medicare || "N/A"}`),
                                new Paragraph(`${t("Profiles.Insurance.MedicaID")}: ${data.Insurance.MedicaID || "N/A"}`),
                                new Paragraph(`${t("Profiles.Insurance.VABenefits")}: ${data.Insurance.VABenefits || "N/A"}`),
                                new Paragraph(`${t("Profiles.Insurance.COBRA")}: ${data.Insurance.COBRA || "N/A"}`),
                                new Paragraph(`${t("Profiles.Insurance.coverage")}: ${data.Insurance.coverage || "N/A"}`),
                                new Paragraph(`${t("Profiles.Insurance.ACA/Private")}: ${data.Insurance.ACA || "N/A"}`),
                                new Paragraph(`${t("Profiles.Insurance.Insurance")}: ${data.Insurance.Insurance || "N/A"}`),
                                ...(data.Insurance.Insurance === "yes" 
                                    ? [new Paragraph(`${t("Profiles.Insurance.NameofInsCo")}: ${data.Insurance.InsuranceCompany || "N/A"}`)]
                                    : []),
                                new Paragraph({ text: "Financial Resources", heading: "Title" }),
                                new Paragraph("Income Sources"),
                                new DocTable({
                                    rows: Object.keys(data.FinancialResources).map(key => (
                                        new DocTableRow({
                                            children: [
                                                new DocTableCell({ children: [new Paragraph(key)] }),
                                                new DocTableCell({ children: [new Paragraph(data.FinancialResources[key].Status || "N/A")] }),
                                                new DocTableCell({ children: [new Paragraph(data.FinancialResources[key].NeedHelpApplying || "N/A")] })
                                            ]
                                        })
                                    ))
                                })
                    ],
                },
            ],
        });

        const blob = await Packer.toBlob(doc);
        saveAs(blob, fileName);
    };

    return (
        <Button variant="contained" color="primary" onClick={handleExportToWord}>
            {t("common.exportToWord")}
        </Button>
    );
};

export default ExportToWord;